import { render, staticRenderFns } from "./QuantFactor.vue?vue&type=template&id=44065e80&"
import script from "./QuantFactor.vue?vue&type=script&lang=js&"
export * from "./QuantFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports